import React, { useEffect, useState } from "react";
import logo from "../images/whitewiley.png";
import axios from "axios";
import config from "../config/config";
var Settings = require("./settings.json");

const Footer = () => {
  const [result, setData] = useState({ data: [] });
  const url = config.BASE_URL + Settings["footerBlockURL"];

  useEffect(() => {
    axios.get(url).then((response) => setData(response.data));
  }, [url]);

  return (
    <div className="footer">
      <div className="wiley-logo">
        <img src={logo} alt="logo" />
      </div>
      <div className="wiley-text-box">
        <p className="wiley-text">
          The content powering this tool is based on the world-renowned
          Blackwell’s Five-Minute Veterinary Consult Series. These books are
          edited by certified veterinarians. The content summarizes the latest
          research.
        </p>
        <div className="copyright-text">
          <p>Copyright</p>
          <p>{new Date().getFullYear()}</p>
        </div>
      </div>
      <p className="writen-by-text">AUTHORS / EDITORS</p>
      <div className="footer-links">
        <div className="writer-names">
          {Object.values(result)[0].map((item, key) => (
            <div key={key} className="writer">
              <p className="writer-about">{item.title}</p>
              <div className="writer-names-row">
                <p className="writer-name">{item.author}</p>
              </div>
            </div>
          ))}

          {/* <div className="writer">
            <p className="writer-about">
          
              Blackwell’s Five-Minute Veterinary Consult:
              <span className="writer-about-caps">CANINE AND FELINE</span>
            </p>
            
            <div className="writer-names-row">
              <p className="writer-name">Larry P. Tilley</p>
            <p className="writer-name">Francis W. K. Smith, Jr.</p>
            </div>
          </div> 
          <div className="writer">
            <p className="writer-about">
              Blackwell’s Five-Minute Veterinary Consult Clinical Companion: Canine and Feline Behavior
            </p>
            
            <div className="writer-names-row">
              <p className="writer-name">Debra F. Horwitz</p>
            </div>
          </div>
          <div className="writer">
            <p className="writer-about">
              Blackwell’s Five-Minute Veterinary Consult Clinical Companion: Small Animal Endocrinology and Reproduction
            </p>
            <div className="writer-names-row">
              <p className="writer-name">Deborah S. Greco</p>
              <p className="writer-name">Autumn P. Davidson</p>
            </div>
        </div> 
        */}
        </div>
        <div className="more-links">
          <ul>
            <li>
              <a
                href="https://www.wiley.com/terms-of-use"
                target="_blank"
                rel="noreferrer"
              >
                Terms of Service
              </a>
            </li>
            <li className="copyright-tab">
              Copyright {new Date().getFullYear()}
            </li>
            <li>
              <a
                href="https://newsroom.wiley.com/newsroom-home/default.aspx"
                target="_blank"
                rel="noreferrer"
              >
                Newsletter
              </a>
            </li>
            <li>
              <a
                href="https://www.wiley.com/privacy"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="https://www.wiley.com/aboutus"
                target="_blank"
                rel="noreferrer"
              >
                About
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
